import dayjs from "dayjs"

type DisplayDuration = { duration: number; unit: string } | undefined

export function durationToAsText(toDate: string | Date): DisplayDuration {
  const units = ["day", "hour", "minute"] as const

  return units.reduce<DisplayDuration>((acc, unit) => {
    if (!acc) {
      const duration = dayjs(toDate).diff(Date.now(), unit)
      if (duration > 0) {
        acc = { duration, unit: duration === 1 ? unit : `${unit}s` }
      }
    }
    return acc
  }, undefined)
}
